import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest, postRequest } from "../../services";
import {
  decryptMessage,
  encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";
import dateFormat from "../../utilities/dateFormat";
import { getUserName } from "../../utilities/utils";

const getPileId = (id: any, pileLIst: any) => {
  const item = pileLIst?.find((val: any) => {
    if (val?.userId === id) {
      return val;
    }
    return undefined;
  });
  if (item !== undefined) {
    return {
      pileId: item.pileId,
      id: item.id,
    };
  } else {
    return {
      pileId: null,
      id: null,
    };
  }
};

export const getWorkInProgressPilesData = createAsyncThunk(
  "Dashboard/work-in-progress piles",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getWIPOpersAndEngs = createAsyncThunk(
  "Dashboard/work-in-progress perators and engineers",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getCompletedPilesTableData = createAsyncThunk(
  "Dashboard/completed piles table data",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getCompletedPilesData = createAsyncThunk(
  "Dashboard/completed piles Headers",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getDiscardedPilesData = createAsyncThunk(
  "Dashboard/discarded or rejected piles",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getTotalManPowerInDetail = createAsyncThunk(
  "Dashboard/Total Manpower In Detail",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getTotalManPower = createAsyncThunk(
  "Dashboard/Total Manpower",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getCurrentEngineersAtSite = createAsyncThunk(
  "Dashboard/Current Engineer At  Site",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getCurrentEngineersAtSiteOverview = createAsyncThunk(
  "Dashboard/Current Engineer At  Site Overview",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getPileLevelDetails = createAsyncThunk(
  "Dashboard/pile level details",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getStepLevelDetails = createAsyncThunk(
  "Dashboard/step level details",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getEngineerLevelDetails = createAsyncThunk(
  "Dashboard/engineer level details",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getStepsDropList = createAsyncThunk(
  "Dashboard/ step droplist details",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getOverAllStatusOfProject = createAsyncThunk(
  "Dashboard/overall status of project",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getEngineersInShift = createAsyncThunk(
  "Dashboard/ Engineers in shift",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const approveUndoDiscardPileId = createAsyncThunk(
  "Dashboard/WIP Approve Undo Discard Pile",
  ({ endPoint, data }: { endPoint: String; data: any }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const rejectUndoDiscardPileId = createAsyncThunk(
  "Dashboard/WIP Approve Undo Discard Pile",
  ({ endPoint, data }: { endPoint: String; data: any }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAvailableMachines = createAsyncThunk(
  "Users/Available Machines",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getUsersInProject = createAsyncThunk(
  "Dashboard/ get user by  role and project id",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getWIPPiles = createAsyncThunk(
  "Dashboard/ get WIP piles using pId",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getTotalEmployees = createAsyncThunk(
  "Dashboard/ All Employees Count",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getPileDetails = createAsyncThunk(
  "Dashboard/ Pile Counts Details",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getOperatorsInShift = createAsyncThunk(
  "Dashboard/ get operator in shift by project id",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res: any) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

type SliceState = {
  loading: boolean;
  workInProgressPilesData: null | "" | Object;
  WIPOpersAndEngs: null | "" | Object;
  completedPilesData: null | "" | Object;
  completedPilesTableData: null | "" | Object;
  discardedPilesData: null | "" | Object;
  stepLevelDetails: null | "" | Object;
  overAllStatusOfProject: null | "" | Object;
  totalManPower: null | "" | Object;
  totalManPowerInDetail: null | "" | Object;
  currentEngineersAtSite: null | "" | Object;
  currentEngineersAtSiteOverview: null | "" | Object;
  pileLevelDetails: null | "" | Object;
  engineerLevelDetails: null | "" | Object;
  stepsDropList: null | "" | Object;
  engineersInShift: null | "" | Object;
  availableMachines: null | "" | Object;
  allUsersInProject: null | "" | Object;
  WIPPiles: null | "" | Object;
  totalEmployeesCount: null | "" | Object | Number;
  pileDetails: null | "" | Object | Number;
  stepsWithCount: null | "" | Object;
  totalDelayHours: null | "" | Object;
  operatorsInShift: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  workInProgressPilesData: [],
  WIPOpersAndEngs: {},
  completedPilesData: [],
  completedPilesTableData: [],
  discardedPilesData: [],
  stepLevelDetails: {},
  overAllStatusOfProject: {},
  totalManPower: [],
  totalManPowerInDetail: {},
  currentEngineersAtSite: [],
  currentEngineersAtSiteOverview: [],
  pileLevelDetails: {},
  engineerLevelDetails: [],
  stepsDropList: [],
  engineersInShift: [],
  availableMachines: [],
  allUsersInProject: [],
  WIPPiles: [],
  totalEmployeesCount: 0,
  pileDetails: {
    wipCount: 0,
    discardedCount: 0,
    completedCount: 0,
  },
  stepsWithCount: [],
  totalDelayHours: 0,
  operatorsInShift:[],
};

const workInProgressPilesData = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setWorkInProgressPilesData(state, action) {
      state.workInProgressPilesData = action.payload;
    },
  },
  extraReducers: (builder) => {
    //Work in progress: Get API CALL START
    builder.addCase(getWorkInProgressPilesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWorkInProgressPilesData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.workInProgressPilesData = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getWorkInProgressPilesData.rejected, (state) => {
      state.loading = true;
    });
    // Get engs and operators
    builder.addCase(getWIPOpersAndEngs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWIPOpersAndEngs.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.WIPOpersAndEngs = data?.data;
      } else {
        toaster("error", data?.message);
      }
    });
    builder.addCase(getWIPOpersAndEngs.rejected, (state) => {
      state.loading = true;
    });
    //Work in progress: Get API CALL ends
    //completed piles: Get API CALL START
    builder.addCase(getCompletedPilesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCompletedPilesData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.completedPilesData = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getCompletedPilesData.rejected, (state) => {
      state.loading = true;
    });
    //Completed Piles Table Data
    builder.addCase(getCompletedPilesTableData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCompletedPilesTableData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        const { allRigs, allUsers, resp } = data?.data;
        state.completedPilesTableData = resp?.map((val: any) => {
          // rigs
          const rigs = allRigs
            ?.filter((r: any) => val?.rigUsed?.includes(r?._id))
            ?.map(
              (val: any) => `${val?.type} ${val?.number}:${val?.machineId}`
            );

          return {
            ...val,
            rigUsed: rigs?.length > 0 ? rigs : "N/A",
            pileFillStartedOn: dateFormat(val?.pileFillStartedOn?.slice(0, 10)),
            pileCompletedOn: dateFormat(val?.pileCompletedOn?.slice(0, 10)),
            workStartedBy: getUserName(val?.workStartedBy, allUsers),
            workCompletedBy: getUserName(val?.workCompletedBy, allUsers),
            pileStartedOn: dateFormat(val?.pileFillStartedOn?.slice(0, 10)),
          };
        });
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getCompletedPilesTableData.rejected, (state) => {
      state.loading = true;
    });
    //completed Piles: Get API CALL Ends
    //discarded/rejected Piles: Get API CALL Starts
    builder.addCase(getDiscardedPilesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDiscardedPilesData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        console.log(data?.data);
        console.log(
          data?.data?.map((val: any) => ({
            histPileId: val?._id,
            id: val?.pileId,
            pileName: val?.pileName,
            discardedAtStep: val?.stepDetails,
            discaredRejectedReason: val?.discardOrRejectedReason,
            discardedRejectedBy: val?.discardOrRejectedBy,
            undoRequestedBy: val?.undoRequestSentBy,
            workStartedBy: val?.workStartedBy,
            pileStatus: val?.status,
            action: val?.action,
            undoApproveOrRejectReason: val?.undoRejectApproveReason,
          }))
        );
        state.discardedPilesData = data?.data?.map((val: any) => ({
          histPileId: val?._id,
          id: val?.pileId,
          pileName: val?.pileName,
          discardedAtStep: val?.stepDetails,
          discaredRejectedReason: val?.discardOrRejectedReason,
          discardedRejectedBy: val?.discardOrRejectedBy,
          undoRequestedBy: val?.undoRequestSentBy,
          workStartedBy: val?.workStartedBy,
          pileStatus: val?.status,
          action: val?.action,
          undoApproveOrRejectReason: val?.undoRejectApproveReason,
        }));
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getDiscardedPilesData.rejected, (state) => {
      state.loading = true;
    });
    //discarded/rejected Piles: Get API CALL Ends
    //Total Manpower: Get API CALL Starts
    builder.addCase(getTotalManPower.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTotalManPower.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        const ranks = data?.message;
        state.totalManPower = data?.data?.map((val: any) => ({
          name: val?.name ? val?.name : val?.subContractor?.ownerName,
          designation: val?.designation
            ? val?.designation
            : val?.subContractor?.type,
          globalRank: val?.subContractor
            ? "NA"
            : ranks?.globalranks.filter(
                (item: any) => item.empId === val?.empId
              )[0]?.rank
            ? ranks?.globalranks.filter(
                (item: any) => item.empId === val?.empId
              )[0]?.rank
            : "NA",
          projectRank: val?.subContractor
            ? "NA"
            : ranks?.projectranks[val?.projectId]?.filter(
                (item: any) => item.empId === val?.empId
              )[0]?.rank
            ? ranks?.projectranks[val?.projectId]?.filter(
                (item: any) => item.empId === val?.empId
              )[0]?.rank
            : "NA",
          currentStatus: val?.currentStatus,
          startedWorkingOnProject: val?.name
            ? dateFormat(val?.startedWorkingOnProject?.slice(0, 10))
            : dateFormat(
                val?.subContractorProject
                  ?.find((val1: any) => val1?.projectId === val?.projectId)
                  ?.fromDate?.slice(0, 10)
              ) || "",
        }));
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getTotalManPower.rejected, (state) => {
      state.loading = true;
    });
    // Total Manpower In details
    builder.addCase(getTotalManPowerInDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTotalManPowerInDetail.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.totalManPowerInDetail = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getTotalManPowerInDetail.rejected, (state) => {
      state.loading = true;
    });
    //Total Manpower: Get API CALL Ends
    //Step level details piles: Get API CALL START
    builder.addCase(getStepLevelDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStepLevelDetails.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.stepLevelDetails = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getStepLevelDetails.rejected, (state) => {
      state.loading = true;
    });
    //Step level details piles: Get API CALL Ends
    //Current Engineers At Site Starts: Get API CALL START
    builder.addCase(getCurrentEngineersAtSite.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCurrentEngineersAtSite.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.currentEngineersAtSite = data?.data;
      } else {
        toaster("error", data?.message);
      }
    });
    builder.addCase(getCurrentEngineersAtSite.rejected, (state) => {
      state.loading = true;
    });
    //Current Engineers At Site Starts: Get API CALL Ends
    //OverAll Projects Details: Get API CALL START
    builder.addCase(getOverAllStatusOfProject.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverAllStatusOfProject.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overAllStatusOfProject = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getOverAllStatusOfProject.rejected, (state) => {
      state.loading = true;
    });
    //OverAll Projects Details: Get API CALL Ends
    // Pile Level Details: Get API CALL START
    builder.addCase(getPileLevelDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPileLevelDetails.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.pileLevelDetails = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getPileLevelDetails.rejected, (state) => {
      state.loading = true;
    });
    // Pile Level Details: Get API CALL Ends
    // Engineer Level Details: Get API CALL START
    builder.addCase(getEngineerLevelDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEngineerLevelDetails.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.engineerLevelDetails = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getEngineerLevelDetails.rejected, (state) => {
      state.loading = true;
    });
    // Engineer Level Details: Get API CALL Ends
    // Steps Drop Details: Get API CALL START
    builder.addCase(getStepsDropList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStepsDropList.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.stepsDropList = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getStepsDropList.rejected, (state) => {
      state.loading = true;
    });
    // Steps Drop Details: Get API CALL Ends

    // get Engs in shift: Get API CALL START
    builder.addCase(getEngineersInShift.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEngineersInShift.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        const pileUserIds = data?.data?.allPiles?.map((val: any) => ({
          id: val?._id,
          pileId: val?.pileId,
          userId: val?.steps?.pop()?.workedBy[0].id,
        }));
        state.engineersInShift = data?.data?.data?.map((val: any) => ({
          ...val,
          pileDetails: getPileId(val?.userId, pileUserIds),
        }));
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getEngineersInShift.rejected, (state) => {
      state.loading = true;
    });
    // get Engs in shift: Get API CALL Ends

    // Undo Discard Pileid: Get API CALL START
    builder.addCase(approveUndoDiscardPileId.pending, (state) => {});
    builder.addCase(approveUndoDiscardPileId.fulfilled, (state, action) => {
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(approveUndoDiscardPileId.rejected, (state) => {
      state.loading = true;
    });
    // Undo Discard Pileid: Get API CALL Ends

    // Undo Discard Pileid: Get API CALL START
    builder.addCase(getCurrentEngineersAtSiteOverview.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getCurrentEngineersAtSiteOverview.fulfilled,
      (state, action) => {
        state.loading = false;
        const data: any =
          process.env.NODE_ENV === "development"
            ? action.payload?.data
            : decryptMessage(JSON.stringify(action.payload?.data));
        if (data?.status) {
          toaster("success", data?.message);
          state.currentEngineersAtSiteOverview = data?.data;
        } else {
          toaster("error", data.message);
        }
      }
    );
    builder.addCase(getCurrentEngineersAtSiteOverview.rejected, (state) => {
      state.loading = true;
    });
    // Undo Discard Pileid: Get API CALL Ends

    //TODO: Post API CALL START
    builder.addCase(getAvailableMachines.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAvailableMachines.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.availableMachines = data?.data;
      } else {
        toaster("error", data?.message);
      }
    });
    builder.addCase(getAvailableMachines.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL ENDS

    // delete Location: Get API CALL START
    builder.addCase(getUsersInProject.pending, (state) => {});
    builder.addCase(getUsersInProject.fulfilled, (state, action) => {
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allUsersInProject = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getUsersInProject.rejected, (state) => {
      state.loading = true;
    });
    // get wip  piles: Get API CALL Ends
    // get wip  piles: Get API CALL START
    builder.addCase(getWIPPiles.pending, (state) => {});
    builder.addCase(getWIPPiles.fulfilled, (state, action) => {
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.stepsWithCount = data?.data?.stepsCount;
        state.totalDelayHours = data?.data?.totalDelay;
        state.WIPPiles = data?.data?.wipPiles?.map((val: any) => {
          return {
            id: val?.id,
            pileId: val?.pileId,
            machineUsed: val?.machineUsed,
            stepNameNumber: `${val?.stepNumber}, ${val?.stepName}`,
            lastWorkedBy: val?.lastWorkedBy,
            startedOn: dateFormat(val?.workStartedOn?.slice(0, 10)),
          };
        });
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getWIPPiles.rejected, (state) => {
      state.loading = true;
    });
    // get wip  piles: Get API CALL Ends
    // get wip  piles: Get API CALL START
    builder.addCase(getTotalEmployees.pending, (state) => {});
    builder.addCase(getTotalEmployees.fulfilled, (state, action) => {
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.totalEmployeesCount = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getTotalEmployees.rejected, (state) => {
      state.loading = true;
    });
    // get wip  piles: Get API CALL Ends

    // get wip  piles: Get API CALL START
    builder.addCase(getPileDetails.pending, (state) => {});
    builder.addCase(getPileDetails.fulfilled, (state, action) => {
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.pileDetails = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getPileDetails.rejected, (state) => {
      state.loading = true;
    });
    // get wip  piles: Get API CALL Ends
    builder.addCase(getOperatorsInShift.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOperatorsInShift.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.operatorsInShift = data?.data;
      } else {
        toaster("error", data.message);
      }
    });
    builder.addCase(getOperatorsInShift.rejected, (state) => {
      state.loading = true;
    });
  },
});
export const { setWorkInProgressPilesData } = workInProgressPilesData.actions;

export default workInProgressPilesData;
